import { DetailPageContainer } from "@src/components/DetailPageComponents/PageContainer";
import { EntityDetailContext, EntityDetailContextValueType } from "../../hooks/useEntityDetailLogic";
import { PropsWithChildren, createContext } from "react";

export const EntityDetailPageContainer:React.FC<PropsWithChildren<{value:EntityDetailContextValueType}>> = (props)=>
(<EntityDetailContext.Provider value={props.value}>
  <DetailPageContainer loading={props.value?.loading}>
    {props.children}
  </DetailPageContainer>
</EntityDetailContext.Provider>)